import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { APPROVED_SALES_LISTING } from "./type";

export const getApprovedSaleListing = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&lead_type=${queryObj.lead_type}&lead_no=${queryObj.leadID}&site_no=${queryObj.siteID}&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&lead_cat=${queryObj.lead_cat}&lcfrom_date=${queryObj.lcfromDate}&lcto_date=${queryObj.lctoDate}&ncfrom_date=${queryObj.ncfromDate}&ncto_date=${queryObj.nctoDate}&page=${page}`;
  }
  
  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;
    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    // if (departmentName && departmentName === 4) {
     
        apiUrl = queryObj
        ? `${Config.preSalesList.financeContractList}?finance=1${filterQuery}`
        : `${Config.preSalesList.financeContractList}?finance=1`;
      
    // }

    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}${queryObj === null && `&page=${page}`}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: APPROVED_SALES_LISTING,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });
  }
};
